<template>
    <div class="cc-voucher">
        <div class="cc-voucher__header">
            <div class="cc-voucher__title">{{ translations['Vouchers'] }}</div>
        </div>
        <div class="cc-voucher__main">
            <div class="cc-voucher__form-input">
                <input v-model="voucherCode" id="voucher" type="text" name="voucher" class="cc-voucher__input cc-voucher__input--text" @keyup.enter="applyVoucher">
                <button class="cc-voucher__button cc-voucher__button--apply" @click="applyVoucher">{{ translations['Ok'] }}</button>
                <div v-if="isInvalid" class="cc-voucher__alert cc-voucher__alert--error">{{ translations['Voucher is invalid'] }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Voucher',
        data () {
            return {
                voucherCode: null,
                isInvalid: false,
                showInput: false
            }
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                vouchers: state => state.voucher.vouchers,
            }),
            showVoucherInput: function () {
                return true;
            },
        },
        methods: {
            applyVoucher: function () {
                this.$store.dispatch('voucher/apply', this.voucherCode)
                    .then((result) => {
                        if (result.state === 'invalid') {
                            this.isInvalid = true;
                            return;
                        }
                        this.isInvalid = false;
                        this.showInput = false;
                        this.voucherCode = '';
                    })
            },
        }
    }
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    .cc-voucher {
        display: block;
        width: 100%;
        max-width: 350px;
        padding: 1.5rem;
        border-width: 1px;
        border-style: solid;
        border-color: $border-color;
    }

    .cc-voucher__header {
        display: block;
        width: 100%;
        max-width: 100%;
    }

    .cc-voucher__title {
        font-size: 20px;
        font-weight: bold;
        text-transform: uppercase;
    }

    .cc-voucher__main {
        display: block;
        width: 100%;
        max-width: 100%;
    }

    .cc-voucher__form-input {
        display: flex;
        align-items: center;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-top: 0.5rem;
    }

    .cc-voucher__input {
        font-weight: normal;
        margin: 0;

        &.cc-voucher__input--text {
            display: block;
            padding: 0.5rem;
            border-width: 1px;
            border-style: solid;
            border-color: $border-color;
            border-radius: 3px;
        }
    }

    .cc-voucher__alert {
        display: block;
        width: 100%;
        margin-top: 0.25rem;

        &.cc-voucher__alert--error {
            color: $red;
        }
    }

    .cc-voucher__button {
        font-weight: bold;
        display: inline-block;
        padding: 0.5rem 1rem;
        cursor: pointer;
        user-select: none;
        text-align: center;
        text-transform: uppercase;
        border-radius: 3px;

        &.cc-voucher__button--apply {
            margin-left: 0.5rem;
            color: $white;
            border-width: 1px;
            border-style: solid;
            border-color: $grey;
            background-color: $grey;
            box-shadow: $default-button-shadow;

            &:active {
                box-shadow: $active-button-shadow;
            }

            &:hover {
                border-color: darken($grey, 5%);
                background-color: darken($grey, 5%);
            }
        }
    }

    .cc-voucher__information {
        display: block;
        width: 100%;
        max-width: 100%;
        margin-top: 0.5rem;
    }
</style>
